import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import { SequenceMenu } from '@sequencehq/core-components'
import { usePermissions } from 'lib/rbac'
import { useNavigate } from 'react-router-dom'

export const PreviewInvoice = (props: {
  invoiceId: string
  invoiceStatus: Dashboardv99990101Api.Invoices.InvoiceStatus
}) => {
  const navigate = useNavigate()
  const { can } = usePermissions()

  if (!can('org.invoice:update')) {
    return null
  }

  return (
    <SequenceMenu.Item
      data-testid="invoices.previewInvoice.menuItem"
      uuid="preview-invoice"
      label={
        props.invoiceStatus === 'DRAFT' ? 'View/Edit invoice' : 'View invoice'
      }
      onClick={() => {
        navigate(`/invoices/${props.invoiceId}`)
      }}
    />
  )
}
